import { Link } from "react-router-dom";

const CookiePolicyPage = () => {
  return (
    <div
      className="min-h-screen bg-brand-background"
      data-testid="cookie-policy-page"
    >
      {/* Hero */}
      <section className="py-16 md:py-20 bg-brand-primary">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-white">
            Cookie Policy
          </h1>
          <p className="text-white/70 mt-4">
            Ultimo aggiornamento: Dicembre 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="prose prose-lg max-w-none text-brand-foreground">
            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              Cosa sono i Cookie
            </h2>
            <p className="text-brand-muted leading-relaxed mb-6">
              I cookie sono piccoli file di testo che i siti visitati inviano al
              terminale dell'utente (computer, tablet, smartphone), dove vengono
              memorizzati per essere ritrasmessi agli stessi siti alla visita
              successiva. I cookie permettono di memorizzare le preferenze
              dell'utente e migliorare l'esperienza di navigazione.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              Tipologie di Cookie Utilizzati
            </h2>

            <h3 className="font-heading text-xl font-semibold text-brand-foreground mt-6 mb-3">
              Cookie Tecnici (Necessari)
            </h3>
            <p className="text-brand-muted leading-relaxed mb-4">
              Questi cookie sono essenziali per il corretto funzionamento del
              sito web e non possono essere disattivati. Includono:
            </p>
            <ul className="list-disc pl-6 text-brand-muted space-y-2 mb-6">
              <li>Cookie di sessione per la navigazione</li>
              <li>Cookie per il salvataggio delle preferenze sui cookie</li>
              <li>Cookie per il funzionamento del chatbot</li>
            </ul>

            <h3 className="font-heading text-xl font-semibold text-brand-foreground mt-6 mb-3">
              Cookie Analitici
            </h3>
            <p className="text-brand-muted leading-relaxed mb-4">
              Questi cookie ci permettono di raccogliere informazioni anonime
              sull'utilizzo del sito per migliorare i nostri servizi. Includono:
            </p>
            <ul className="list-disc pl-6 text-brand-muted space-y-2 mb-6">
              <li>Numero di visitatori</li>
              <li>Pagine più visitate</li>
              <li>Tempo di permanenza sul sito</li>
              <li>Sorgenti di traffico</li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              Gestione dei Cookie
            </h2>
            <p className="text-brand-muted leading-relaxed mb-4">
              L'utente può gestire le preferenze sui cookie in diversi modi:
            </p>
            <ul className="list-disc pl-6 text-brand-muted space-y-2 mb-6">
              <li>
                <strong>Banner Cookie:</strong> Al primo accesso al sito, è
                possibile accettare tutti i cookie o solo quelli necessari
              </li>
              <li>
                <strong>Impostazioni del Browser:</strong> È possibile
                configurare il browser per bloccare o eliminare i cookie
              </li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              Come Disabilitare i Cookie dal Browser
            </h2>
            <p className="text-brand-muted leading-relaxed mb-4">
              Di seguito i link alle guide per la gestione dei cookie nei
              principali browser:
            </p>
            <ul className="list-disc pl-6 text-brand-muted space-y-2 mb-6">
              <li>
                <a
                  href="https://support.google.com/chrome/answer/95647"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-primary hover:underline"
                >
                  Google Chrome
                </a>
              </li>
              <li>
                <a
                  href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-primary hover:underline"
                >
                  Mozilla Firefox
                </a>
              </li>
              <li>
                <a
                  href="https://support.apple.com/it-it/guide/safari/sfri11471/mac"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-primary hover:underline"
                >
                  Safari
                </a>
              </li>
              <li>
                <a
                  href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-primary hover:underline"
                >
                  Microsoft Edge
                </a>
              </li>
            </ul>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              Cookie di Terze Parti
            </h2>
            <p className="text-brand-muted leading-relaxed mb-6">
              Questo sito potrebbe utilizzare cookie di terze parti per
              l'integrazione di mappe (Google Maps) e per analisi statistiche
              anonime. Questi cookie sono soggetti alle rispettive privacy
              policy dei fornitori terzi.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              Aggiornamenti alla Cookie Policy
            </h2>
            <p className="text-brand-muted leading-relaxed mb-6">
              Questa Cookie Policy può essere aggiornata periodicamente. La data
              dell'ultimo aggiornamento è indicata all'inizio di questa pagina.
              Ti invitiamo a consultare regolarmente questa pagina per rimanere
              informato sulle modalità di utilizzo dei cookie.
            </p>

            <h2 className="font-heading text-2xl font-semibold text-brand-foreground mt-8 mb-4">
              Contatti
            </h2>
            <p className="text-brand-muted leading-relaxed">
              Per qualsiasi domanda relativa all'utilizzo dei cookie su questo
              sito, è possibile contattarci attraverso la pagina{" "}
              <Link
                to="/contatti"
                className="text-brand-primary hover:underline"
              >
                Contatti
              </Link>{" "}
              o consultare la nostra{" "}
              <Link
                to="/privacy-policy"
                className="text-brand-primary hover:underline"
              >
                Privacy Policy
              </Link>
              .
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicyPage;
